const genMarkup = (url) => `
  <iframe src="${url}?autoplay=1&mute=1" frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen></iframe>
  `;
(function () {
  const videos = document.querySelectorAll('.video');

  videos.forEach((video) => {
    const embedUrl = video.getAttribute('data-embed');
    const embed = genMarkup(embedUrl);

    const target = video.querySelector('.video__embed');

    // / if video has class "video--autoplay" then autoplay when in view else play on click
    if (video.classList.contains('video--autoplay')) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            target.innerHTML = embed;
            target.closest('.video').classList.add('is-active');
          }
        });
      });
      observer.observe(video);
    } else {
      video.addEventListener('click', (evt) => {
        evt.preventDefault();

        target.innerHTML = embed;
        target.closest('.video').classList.add('is-active');
      });
    }
  });
})();
